var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-dashboard-4801039",
    transform: "translate(-94.278 -22.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M111.837,22.6h6.706a2.735,2.735,0,0,1,2.735,2.717V46.881a2.735,2.735,0,0,1-2.735,2.717h-6.706a2.735,2.735,0,0,1-2.735-2.717V25.315A2.735,2.735,0,0,1,111.837,22.6Zm-14.824,18.5h6.706a2.735,2.735,0,0,1,2.735,2.717v3.068a2.735,2.735,0,0,1-2.735,2.717H97.013a2.735,2.735,0,0,1-2.735-2.717V43.812A2.735,2.735,0,0,1,97.013,41.095Zm0-18.5h6.706a2.735,2.735,0,0,1,2.735,2.717V35.923a2.735,2.735,0,0,1-2.735,2.717H97.013a2.735,2.735,0,0,1-2.735-2.717V25.315A2.735,2.735,0,0,1,97.013,22.6Z",
    transform: "translate(0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.bf69ec5974424ecc7432ce3c606c0074.svg";
export { ForwardRef as ReactComponent };